import * as yup from 'yup';

export const validationSchema = yup.object({
    name: yup
        .string()
        .required('Заполните поле')
        .min(2, 'Поле должно содержать не менее 2 символов')
        .max(40, 'Должно быть не более 40 символов.'),
    contact: yup
        .string()
        .required('Заполните поле')
        .test('phone', 'Неверный формат', (value: string | any): boolean => {
            const regexPhone =
                /^(\+7|7|8)?[\s-]?\(?[489][0-9]{2}\)?[\s-]?[0-9]{3}[\s-]?[0-9]{2}[\s-]?[0-9]{2}$/;
            return regexPhone.test(value);
        }),
    message: yup.string(),
});
